<template>
    <div v-if="installation" class="installation-selection__item">
        <div class="selected-icon">
            <span :class="`vrm-icon ${device.class || ''}`"></span>
        </div>
        <div>
            <div class="installation-selection__item-title">
                {{ installation.name }}
                {{ device.productName ? ' | ' + device.productName : '' }}
            </div>
            <div class="installation-selection__item-detail-container">
                <template v-if="installation.syscreated">
                    {{ $t('installationoverview.dateAdded', { i18nFallback: 'Date added' }) }}
                    <span>{{ formatDate(installation.syscreated) }}</span>
                </template>
                <template v-if="device.lastConnection">
                    {{
                        $t('installationoverview.lastConnection', {
                            i18nFallback: 'Last connection',
                        })
                    }}
                    <span>{{ formatDate(device.lastConnection) }}</span>
                </template>

                <template v-if="extended">
                    <template v-if="device.machineSerialNumber">
                        {{
                            $t('overview.machine_serial_number', { i18nFallback: 'Serial number' })
                        }}
                        <span>{{ device.machineSerialNumber }}</span>
                    </template>
                    <template v-if="installation.identifier">
                        {{ $t('overview.identifier', { i18nFallback: 'VRM Portal ID' }) }}
                        <span>{{ installation.identifier }}</span>
                    </template>
                </template>
            </div>
        </div>
    </div>
</template>
<script>
import { Vue, Component, Prop } from 'vue-property-decorator';
import { AngularDirective } from '@/vue/decorators/angular-interop';
import { AngularLocaleBundle } from '@/angular-bridge/modules/i18n';
import moment from 'moment';

@Component
@AngularDirective('vrm-installation-card')
@AngularLocaleBundle('installationoverview')
@AngularLocaleBundle('overview')
export default class vrmInstallationCard extends Vue {
    @Prop({ required: true })
    installation;

    @Prop()
    extended;

    formatDate(time) {
        return moment.unix(time).format('YYYY-MM-DD');
    }

    get device() {
        return this.installation.gateway || {};
    }
}
</script>
